export default __webpack_public_path__ + "static/proxima-nova-400-3607a788be46b280753e159a176e8fae.woff";